import type { ReactNode } from 'react';
import { BrowserRouter } from 'react-router';
import { ThemeProvider } from './ThemeProvider';
import { SmoothScrollProvider } from './SmoothScrollProvider';
import { ScrollToTop } from '@components/layout/ScrollToTop';
import SkipLink from '@/components/layout/SkipLink';

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <SmoothScrollProvider>
          <SkipLink />
          <ScrollToTop />
          {children}
        </SmoothScrollProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
